<template>
  <div class="BSW-widget-input-description">
    <div v-if="content !== '' && content !== undefined && !customActivator">
      <v-btn
        height="20"
        width="20"
        icon
        class="BSW-widget-input-description__btn"
        @click="modal = true"
      >
        <v-icon size="18">mdi mdi-information-variant</v-icon>
      </v-btn>
    </div>

    <DefaultModal
      max-width="800"
      :modal="modal || customActivatorModal"
      @close="close"
      hide-main-text
    >
      <template #title>{{ title }}</template>
      <template #text><div v-html="content"></div></template>
    </DefaultModal>
  </div>
</template>

<script>
export default {
  name: "InputDescription",
  props: {
    content: {
      type: String,
    },
    title: {
      type: String,
    },
    customActivatorModal: {
      type: Boolean,
    },
    customActivator: {
      type: Boolean,
    },
  },

  data() {
    return {
      modal: false,
    };
  },

  methods: {
    close() {
      this.modal = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.BSW-widget-input-description {
  width: 24px;


  :deep(.v-btn) {
    padding: 0 12px;
    &::before {
      background: none;
    }

    .v-ripple__container {
      display: none;
    }
  }


  &__btn {
    margin-top: -6px;
    border-radius: 50%;
    color: #969897 !important;

    :hover {
      color: var(--main-color) !important;
    }
  }
  &__eye:after {
    display: none;
  }
}
</style>
